import axios from '../http'
import {API} from "../const"


const api = API+'/goods/search';

const error = (name) => (e) => console.error(name + ':=>', e);

export default function listGoods(params, cb, fcb = error('listGoods')) {
  axios.get(api, {params}).then(d => cb(d.data.goods)).catch(d => fcb(d))
}